import React from "react";
import { Placeholder } from "@/pages/Placeholder";

export const Results = () => {
  return <Placeholder />;
};
